import { OrganizationResponse } from 'src/modules/organization/models/organizationResponse';
import { OrganizationRequest } from 'src/modules/organization/models/organizationRequest';
import { OrganizationTitleRequest } from 'src/modules/organization/models/organizationTitleRequest';
import { OrganizationTitleConfigRequest } from 'src/modules/organization/models/organizationTitleConfigRequest';
import { OrganizationTitleConfigResponse } from 'src/modules/organization/models/organizationTitleConfigResponse';
import { OrganizationFeeRequest } from 'src/modules/organization/models/organizationFeeRequest';
import AxiosInstance from './axios/interceptor';
import { PagedResult } from '../models/pagedResult';
import { OrganizationTitleTypeEnum } from '../models/enums/organizationTitleType.enum';

const controller = 'organization';
export const getAllOrganizations = (searchFilter?: number) => {
  return AxiosInstance.get<PagedResult<OrganizationResponse>>(controller, { params: searchFilter });
};

export const getorganizationById = (id: string | undefined) => {
  return AxiosInstance.get<OrganizationResponse>(`${controller}/${id}`);
};

export const updateorganization = (data: OrganizationRequest) => {
  return AxiosInstance.put(controller, data);
};

export const getOrganizationBoard = () => {
  return AxiosInstance.get(`${controller}/Board`);
};

export const getOrganizationRoles = () => {
  return AxiosInstance.get(`${controller}/Roles`);
};

export const getOrganizationFee = () => {
  return AxiosInstance.get(`${controller}/MemberFee`);
};

export const updateOrganizationFee = (data: OrganizationFeeRequest) => {
  return AxiosInstance.put(`${controller}/MemberFee`, data);
};

export const updateOrganizationBoardTitle = (data: OrganizationTitleRequest) => {
  return AxiosInstance.put(`${controller}/BoardTitle`, data);
};

export const updateOrganizationRoleTitle = (data: OrganizationTitleRequest) => {
  return AxiosInstance.put(`${controller}/RoleTitle`, data);
};

export const updateOrganizationBoardTitleConfig = (data: OrganizationTitleConfigRequest) => {
  return AxiosInstance.put(`${controller}/BoardConfig`, data);
};

export const updateOrganizationRoleTitleConfig = (data: OrganizationTitleConfigRequest) => {
  return AxiosInstance.put(`${controller}/RoleConfig`, data);
};

export const getOrganizationTitleConfigByType = (type: OrganizationTitleTypeEnum) => {
  return AxiosInstance.get<OrganizationTitleConfigResponse[]>(`${controller}/TitleConfig/${type}`);
};
